export const loadScript = async (uris: Array<string>) => {
  const $head = document.querySelector('head')
  const promises: Array<Promise<any>> = new Array<Promise<any>>()
  if ($head) {
    uris.forEach(item => {
      promises.push(
        new Promise(resolve => {
          const script = document.createElement('script')
          script.src = item
          script.onload = function() {
            resolve()
          }
          $head.appendChild(script)
        })
      )
    })
  }
  return Promise.all(promises)
}

export const loadCss = (uris: Array<string>) => {
  const $head = document.querySelector('head')
  if ($head) {
    uris.forEach(item => {
      const link = document.createElement('link')
      link.href = item
      link.setAttribute('rel', 'stylesheet')
      link.setAttribute('type', 'text/css')
      $head.appendChild(link)
    })
  }
}
